import type { FC } from 'react';
import { IoCheckmarkOutline } from 'react-icons/io5';

import { Menu } from '@mantine/core';

import { ComponentApplication, ComponentApplicationOptions } from 'models';

import { useComponentSearchFilters } from 'components/component-overview/hooks/use-component-search-filters';
import { InlineFilters } from 'components/component-overview/inline-filters/InlineFilters';
import { SearchService } from 'components/component-overview/services/SearchService';

const InlineFiltersApplication: FC = () => {
    const { application } = useComponentSearchFilters();

    const onClick = (value: ComponentApplication) => {
        SearchService.setFilter(
            'application',
            application?.includes(value)
                ? application.filter((_application) => _application !== value)
                : [...(application ?? []), value],
        );
    };

    const formattedValue = ComponentApplicationOptions.filter(({ value }) => application?.includes(value))
        .map(({ label }) => label)
        .join(', ');

    if (application === undefined) return null;

    return (
        <InlineFilters.Section
            label={!application?.length ? 'Application' : ''}
            body={formattedValue}
            active={!!application?.length}
            popoverContent={
                <>
                    <Menu.Label>Application</Menu.Label>
                    {ComponentApplicationOptions.map(({ value, label }) => (
                        <Menu.Item
                            key={value}
                            onClick={() => onClick(value)}
                            leftSection={application?.includes(value) ? <IoCheckmarkOutline /> : null}
                        >
                            {label}
                        </Menu.Item>
                    ))}
                </>
            }
            onRemove={() => SearchService.setFilter('application', undefined)}
        />
    );
};

export { InlineFiltersApplication };
